import { TimelineCategory } from '../types';
import { CATEGORY_COLORS } from '../constants';

export const getCategoryColor = (category: TimelineCategory, type: 'bg' | 'text' | 'light' = 'bg'): string => {
  return CATEGORY_COLORS[category]?.[type] || 'bg-gray-500';
};

export const getCategoryLabel = (category: TimelineCategory): string => {
  return category.charAt(0).toUpperCase() + category.slice(1);
};